const printIcons = document.querySelectorAll('#print__icon')

printIcons.forEach(printIcon => {
    printIcon.addEventListener('click', function () {
        window.print();
    });
})